export const formatTimeScore = (time) => {
  let minutes = Math.floor(time / 60);
  let seconds = Math.floor(time % 60);
  let milliseconds = Math.floor((time * 1000) % 1000);

  if (minutes.toString().length < 2) {
    minutes = "0" + minutes;
  }
  if (seconds.toString().length < 2) {
    seconds = "0" + seconds;
  }
  if (milliseconds.toString().length < 2) {
    milliseconds = "00" + milliseconds;
  } else if (milliseconds.toString().length < 3) {
    milliseconds = "0" + milliseconds;
  }

  return `${minutes}:${seconds}:${milliseconds}`;
};
